const getArrQuery = (
  val: undefined | string | number | (string | number)[]
): (string | number)[] => {
  if (!val) return []
  if (typeof val === 'string' || typeof val === 'number') return [val]
  return val
}

export default getArrQuery
